import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { DirectivesModules } from '../shared/directives/directives.module';
import { OptionsRoutingModule } from './options-routing.module';

import { ComponentsModules } from '../shared/components/components.module';
import { OptionsComponent} from './options.component';


@NgModule({
  declarations: [
    OptionsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModules,
    DirectivesModules,
    OptionsRoutingModule,
  ],
  providers: [
  ],
  exports: [
    OptionsComponent,
  ],
})
export class OptionsModule {}
